var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConference(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5,8.5a3.37,3.37,0,0,1-1,2.48A3.36,3.36,0,0,1,21,12a3.12,3.12,0,0,1-1.22-.23,3.88,3.88,0,0,1-1.08-.62,7.37,7.37,0,0,0-2.25,2A4.94,4.94,0,0,0,15.5,16H42L40,30H31.3V27h6.25c.2-1.33.39-2.67.57-4s.38-2.67.58-4H9.3c.2,1.33.39,2.67.58,4s.37,2.67.57,4H16.7v3H8L6,16h6.5a8,8,0,0,1,1.42-4.45A9.82,9.82,0,0,1,17.5,8.4a3.5,3.5,0,0,1,6-2.38A3.37,3.37,0,0,1,24.5,8.5ZM18.7,39H29.3l1.4-14H17.3ZM16,42,14.35,25.3a3,3,0,0,1,.8-2.3,2.83,2.83,0,0,1,2.2-1h13.3a2.83,2.83,0,0,1,2.2,1,3,3,0,0,1,.8,2.3L32,42Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConference);
export default __webpack_public_path__ + "static/media/conference.1d49dec0fbdc9f5174500e844aca593d.svg";
export { ForwardRef as ReactComponent };